
<div class="d-flex gx-2 mt-2">
    <div class="text-secondary pe-1">
        <i class="fa-solid" [ngClass]="{'fa-comment':allowComments, 'fa-comment-slash': !allowComments}"></i>
    </div>
    <div class="">
        <div class="comments px-3">
            @if(allowComments){
            {{'poll_creation.customize_allow_comments_preview' | translate}}
            } @else {
            {{'poll_creation.customize_not_allow_comments_preview' | translate}}
            }
        </div>
    </div>
</div>